/**
 * Constants related to report access restrictions for BNY users
 */

/**
 * User preference key for report access only restriction
 */
export const REPORT_ACCESS_ONLY_PREFERENCE_KEY = 'application:reportAccessOnly';

/**
 * Feature toggle for BNY management report access restrictions
 */
export const REPORT_ACCESS_RESTRICTION_FEATURE_TOGGLE = 'bny-management-report-isd-9062';

/**
 * Account preference key for BNY Branding
 */
export const BNY_BRANDING_PREFERENCE_KEY = 'application:branding';

/**
 * Account preference value for BNY Branding
 */
export const BNY_BRANDING_PREFERENCE_VALUE = 'bny';
